/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { InvoiceDocument } from '../../models/invoice-document';

export interface GetInvoiceDocument$Params {
  uuid: string;
}

export function getInvoiceDocument(http: HttpClient, rootUrl: string, params: GetInvoiceDocument$Params, context?: HttpContext): Observable<StrictHttpResponse<InvoiceDocument>> {
  const rb = new RequestBuilder(rootUrl, getInvoiceDocument.PATH, 'get');
  if (params) {
    rb.path('uuid', params.uuid, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<InvoiceDocument>;
    })
  );
}

getInvoiceDocument.PATH = '/invoice-document/{uuid}';
